/**
 * Lets other open tabs of the site know a sign-in finished here. An email
 * sign-in link always opens a new tab, so the tab the user started from would
 * otherwise sit on the login page while they are signed in. Firebase already
 * shares the session between tabs; this only tells the login page to move on.
 */
const CHANNEL = 'journey-sign-in'

// BroadcastChannel also delivers to other channels in the same tab, so each
// message names its tab and a tab ignores its own.
const TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`

export function announceSignIn(uid) {
  if (typeof BroadcastChannel === 'undefined') return
  try {
    const channel = new BroadcastChannel(CHANNEL)
    channel.postMessage({ type: 'signed-in', uid, from: TAB_ID })
    channel.close()
  } catch (err) {
    console.warn('announceSignIn failed:', err)
  }
}

/** Calls `handler({ uid })` when another tab announces a sign-in. Returns a stop function. */
export function onSignInElsewhere(handler) {
  if (typeof BroadcastChannel === 'undefined') return () => {}
  const channel = new BroadcastChannel(CHANNEL)
  channel.onmessage = (event) => {
    const data = event.data
    if (data && data.type === 'signed-in' && data.from !== TAB_ID) handler(data)
  }
  return () => channel.close()
}
